// BrowswerHistory common instance creator
// https://github.com/ReactTraining/history

import createHistory from 'history/createBrowserHistory'

export default createHistory()
